import firebase from "firebase";

const auth = {
    namespaced: true,
    state: {
        user: null,
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
    },
    getters: {
        getUser: state => {
            return state.user;
        },
        isSignIn: state => {
            //let user = firebase.auth().currentUser;
            return state.user;// && state.user.uid === user.uid;
        }
    },
    actions: {
        signIn({commit}, auth) {
            commit("setUser", null);
            commit('setLoading', true, {root: true});
            commit('setError', null, {root: true});

            if (auth.provider === "email") {
                return firebase.auth().signInWithEmailAndPassword(auth.username, auth.password)
                    .then((result) => {
                        let user = {
                            uid: result.user.uid,
                            email: result.user.email
                        };
                        commit("setUser", user);
                        return Promise.resolve();
                    }).catch((error) => {
                        commit('setError', error.message, {root: true});
                        return Promise.reject(error.message);
                    })
                    .finally(() => {
                        commit("setLoading", false, {root: true});
                    });
            } else if (auth.provider === "google") {
                let provider = new firebase.auth.GoogleAuthProvider();
                provider.setCustomParameters()
                return firebase.auth().signInWithPopup(provider)
                    .then(() => {
                        // let user = {
                        //     uid: result.user.uid,
                        //     email: result.user.email
                        // };
                        //commit("setUser", user);
                        //return Promise.resolve();
                        return Promise.reject("not implemented");
                    }).catch((error) => {
                        commit('setError', error.message, {root: true});
                        return Promise.reject(error.message);
                    })
                    .finally(() => {
                        commit("setLoading", false, {root: true});
                    });
            } else {
                commit('setError', "Auth failed", {root: true});
                commit("setLoading", false, {root: true});
                return Promise.reject("unknown provider");
            }
        },
        signOut({commit}) {
            commit('setLoading', true, {root: true});
            commit('setError', null, {root: true});
            return firebase.auth().signOut()
                .then(() => {
                    commit("setUser", null);
                }).catch((error) => {
                    commit('setError', error.message, {root: true});
                }).finally(() => {
                    commit("setLoading", false, {root: true});
                });
        }
    },
};

export default auth;